import { useField } from "formik";
import SwitchNodeType from "../../types/SwitchNodeType";

import FormControlLabel from "@mui/material/FormControlLabel";
import MuiSwitch from "@mui/material/Switch";

export const Switch = ({ name, label, ...props }: SwitchNodeType) => {
    const [field] = useField(name);

    return (
        <FormControlLabel
            control={
                <MuiSwitch
                    checked={!!field.value}
                    {...props}
                    onChange={(e) => {
                        field.onChange({
                            target: {
                                name,
                                value: e.target.checked,
                            },
                        });
                    }}
                />
            }
            label={label}
        />
    );
};

export default Switch;
